// Hook: formatear horas en local HH:mm evitando desfases por UTC
// Expone helpers seguros para convertir Date a cadena y viceversa

export interface TimeFormatApi {
  // convertir Date a "HH:mm" en hora local
  toHHmmLocal: (date?: Date | null) => string;
  // construir Date del día de hoy usando una cadena "HH:mm" local
  fromHHmmLocal: (hhmm?: string | null) => Date | null;
}

export function useTimeFormat(): TimeFormatApi {
  // toHHmmLocal: usa getHours()/getMinutes() para evitar UTC
  const toHHmmLocal = (date?: Date | null): string => {
    // si no hay valor, retornar cadena vacía
    if (!date) return "";
    // extraer horas y minutos locales
    const h = date.getHours();
    const m = date.getMinutes();
    // rellenar con cero a la izquierda
    const hh = h < 10 ? `0${h}` : String(h);
    const mm = m < 10 ? `0${m}` : String(m);
    // devolver en formato HH:mm
    return `${hh}:${mm}`;
  };

  // fromHHmmLocal: crea Date de hoy con hora:minuto locales
  const fromHHmmLocal = (hhmm?: string | null): Date | null => {
    // validar entrada
    if (!hhmm || typeof hhmm !== 'string' || !/^\d{2}:\d{2}$/.test(hhmm)) return null;
    // separar horas y minutos
    const [hh, mm] = hhmm.split(':').map((v) => parseInt(v, 10));
    // crear base del día actual
    const now = new Date();
    // construir nueva fecha en local
    const d = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hh, mm, 0, 0);
    // retornar la instancia
    return d;
  };

  // exponer API del hook
  return { toHHmmLocal, fromHHmmLocal };
}


